module.exports = __webpack_public_path__ + "static/google-5403fc77e07d2f6f84a2a35d7bb44084.png";